module.exports = __webpack_public_path__ + "img/arrow-left.dd0bd4a8.svg";